export const isSupportedNotification = () =>
  'Notification' in window &&
  'serviceWorker' in navigator &&
  'PushManager' in window;
